import React from "react";

import { formatMoney } from "../financeMoney";

const WalletCard = ({ balance, busy = false, onWithdraw, onTopUp }) => (
  <section className="fin-wallet">
    <span className="fin-wallet-blob fin-wallet-blob-a" aria-hidden="true" />
    <span className="fin-wallet-blob fin-wallet-blob-b" aria-hidden="true" />
    <span className="fin-wallet-blob fin-wallet-blob-c" aria-hidden="true" />

    <span className="fin-wallet-glyph" aria-hidden="true">
      <svg viewBox="0 0 24 24">
        <rect x="3" y="6" width="18" height="13" rx="3" />
        <path d="M3 10h18" />
        <circle cx="17" cy="14.5" r="1.2" />
      </svg>
    </span>

    <p className="fin-wallet-label">Wallet Balance</p>
    <p className="fin-wallet-amount">{formatMoney(balance)}</p>

    <div className="fin-wallet-actions">
      <button
        type="button"
        className="fin-wallet-btn fin-wallet-btn-outline"
        disabled={!(balance?.value > 0)}
        onClick={onWithdraw}
      >
        Withdraw
      </button>

      <button
        type="button"
        className="fin-wallet-btn fin-wallet-btn-filled"
        disabled={busy}
        onClick={onTopUp}
      >
        {busy ? "Working…" : "Top-Up"}
      </button>
    </div>
  </section>
);

export default WalletCard;
